<script lang="ts">
	import type { OrderSide } from '$lib/types/userInteract';
	import { quadIn, quadInOut } from 'svelte/easing';
	import { fly } from 'svelte/transition';
	import {
		longOrShort,
		maxInputAmount,
		minInputAmount,
		leverage,
		input,
		isTPSLActive
	} from './store';
	import { getPostTradeDetails } from '$lib/data/userInteract';

	function setOrderSide(side: OrderSide) {
		if ($longOrShort != side) {
			$isTPSLActive = false;
			$longOrShort = side;
			getPostTradeDetails();
		}
	}
</script>

<div class="grid grid-cols-2 w-full text-sm">
	<div class="cursor-pointer flex-col">
		<div
			class="text-center py-4 {$longOrShort === 'Long'
				? 'text-base font-semibold transition-all duration-150 ease-in-out'
				: ''}"
			class:text-fx-gradient-23={$longOrShort === 'Long'}
			class:text-fx-grey-300={$longOrShort !== 'Long'}
			on:click={() => setOrderSide('Long')}
			on:keydown={() => setOrderSide('Long')}
		>
			Long
		</div>
		{#if $longOrShort == 'Long'}
			<div
				in:fly={{
					duration: 50,
					x: 100,
					y: 0,
					opacity: 0.5,
					easing: quadInOut
				}}
			>
				<div class="bg-fx-gradient-23 h-[2px]" />
			</div>
		{:else}
			<div class="bg-fx-grey-500 h-px" />
		{/if}
	</div>
	<div class="cursor-pointer flex-col">
		<div
			class="text-center py-4 {$longOrShort === 'Short'
				? 'text-base font-semibold transition-all duration-150 ease-in-out'
				: ''}"
			class:text-fx-gradient-22={$longOrShort === 'Short'}
			class:text-fx-grey-300={$longOrShort !== 'Short'}
			on:click={() => setOrderSide('Short')}
			on:keydown={() => setOrderSide('Short')}
		>
			Short
		</div>
		{#if $longOrShort == 'Short'}
			<div
				in:fly={{
					duration: 50,
					x: -100,
					y: 0,
					opacity: 0.5,
					easing: quadInOut
				}}
			>
				<div class="bg-fx-gradient-22 h-[2px]" />
			</div>
		{:else}
			<div class="bg-fx-grey-500 h-px" />
		{/if}
	</div>
</div>
